import React, { useContext } from 'react';
import { SessionContext } from '../SessionContext';

const UserTracker = () => {
    const { userId } = useContext(SessionContext);
  
    return (
      <div>
        <h2>User Tracker</h2>
        <p><strong>User ID:</strong> {userId}</p>
      </div>
    );
  };
  
  export default UserTracker;